module.exports = __webpack_public_path__ + "assets/2f8864f2361eb32fdc1fa5e679eac2aa.svg";